module.exports = "/_next/static/images/HeroCCPA-b3b47e3ba7d5b6294cdeb67532276954.webp";